export const validateRulesFieldValue = (value: string, min: number, max: number): React.ReactText => {
  let tempValue = Number(value);
  if (tempValue >= max) {
    tempValue = max;
  } else if (tempValue <= min) {
    tempValue = min;
  }
  return tempValue;
};

export const checkTheTimeIsValid = (value: number | undefined, minHours: number, minMinutes: number): boolean => {
  let isTimeValid = false;
  if (value) {
    if (Math.floor(value / 3600) >= minHours) {
      isTimeValid = true;
    } else if (Math.floor(value / 60) >= minMinutes) {
      isTimeValid = true;
    }
  }
  return isTimeValid;
};

export const checkThePercentageAndCasesAreValid = (value: number | undefined, minValue: number): boolean => {
  let isValid = false;
  if (value && value >= minValue) {
    isValid = true;
  }
  return isValid;
};
